import createModel from './lib/create_model';

const FbPageAccountSecretContent = createModel({
  modelName: 'FbPageAccountSecretContent',
  properties: {
    authToken: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FbPageAccountSecretContent;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/fb_page_account_secret_content.js